var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mime-icon text-primary"},[_c('i',{staticClass:"far",class:_vm.icon})])}
var staticRenderFns = []

export { render, staticRenderFns }